import { module as modujs } from "modujs";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.$medias = this.$("media");

		this.$medias.forEach((el, index) => {
			const direction = index % 2 === 0 ? -1 : 1; // 1 for up, -1 for down

			gsap.to(el, {
				y: `${direction * 10}%`,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "bottom top",
				},
			});
		});
	}

	destroy() {}
}
